/* global $ */
import { hasIOSupport } from '../helpers/feature-detects';

if (window.llItems.length) {
  $(window.llItems).each((i, el) => {
    $.get({ url: el.src, dataType: 'text' }).done((text) => {
      console.log(text);
      const d = document.createElement('span');
      d.innerHTML = text;
      el.parentNode.replaceChild(d, el);
    });
  });
}

// moves data-src/sizes/scrset to native attributes
const lazyLoadFromDataAttr = (el) => {
  const data = $(el).data();
  const { src, srcset, sizes } = data;
  // console.log({ data });
  if (src) {
    el.src = src;
  }
  if (srcset) {
    el.srcset = srcset;
  }
  if (sizes) {
    el.sizes = sizes;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const modules = document.querySelectorAll('[data-module]');
  if (hasIOSupport) {
    const moduleObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          const { isIntersecting, target } = entry;
          if (isIntersecting) {
            $(target)
              .find('img,source')
              .each((i, el) => {
                lazyLoadFromDataAttr(el);
                observer.unobserve(target);
              });
          }
        });
      },
      {
        rootMargin: '-100px 0px -100px 0px',
        threshold: [0, 1],
      },
    );

    modules.forEach((v) => {
      moduleObserver.observe(v);
    });
  } else {
    $(modules)
      .find('img,source')
      .each((i, el) => {
        lazyLoadFromDataAttr(el);
      });
  }
});
